import React from 'react'
import ReactDOM from 'react-dom'
import NavBar from '../layout/NavBar'
import TopBar from '../layout/TopBar'
import ShowInvoiceView from './ShowInvoiceView'
import { useParams } from 'react-router-dom'

export default class ShowInvoiceApp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      userName: 'Soporte',
      searchPlaceholder: ''
    }
  }

  render() {
    return (
      <div>
        <div>
          <div>
            <TopBar
              searchPlaceholder={this.state.searchPlaceholder}
              userName={this.state.userName}
            />
          </div>
          <div>
            <ShowInvoiceRouteView />
          </div>
        </div>
        <div>
          <NavBar activeItem="Reportes" isEditing={false} />
        </div>
      </div>
    )
  }
}

function ShowInvoiceRouteView() {
  const { id } = useParams()
  return <ShowInvoiceView invoiceUuid={id} />
}
